(async function () {
    try {
        let discountWidget
        let widgetSettings = JSON.parse(sessionStorage.getItem("niftyWidgetSession"));

        if(!widgetSettings) {
            const res = await fetch(
                `https://app.niftybridge.io/api/shop/shop-widget-settings?shop=${Shopify.shop}`
            );
            widgetSettings = await res.json()
        }

        if(widgetSettings && widgetSettings.length) {

            function addDiscountWidget(isWidget, widgetParams) {
                if(!isWidget) {
                    try{
                        const discountWidgetWrapper = document.querySelector('#nftDiscountWidget')
                        if(discountWidgetWrapper) {
                            discountWidgetWrapper.remove()
                        }
                        unmountWidgetDiscount()

                    }catch(e){}
                    return
                }

                const discountWidgetParams = {
                    mode: 1,
                    parentElement: document.querySelector("#nftDiscountWidget"),
                    //networkId: widgetParams.networkId,
                    buttonClassName: widgetParams.buttonClass || null,
                    //collectionAddresses: JSON.parse(widgetParams.collections),
                    walletsToInclude: JSON.parse(widgetParams.walletsToInclude) || null,
                    buttonTitle: widgetParams.buttonTitle || "Verify NFT",

                    networkId: 137,
                    collectionAddresses:  ["0x8DadB6b9E29C51b1273EEfDF9A30455F243A0951", "0x9a14E158C25A1DBE432e3eD2315AEA1Ba251Da5D"],

                    onConfirmCallback: async (params) => {
                        const rawResponse = await fetch(
                            `${APP_HOST}/api/discount-code/create`,
                            {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    shopDomain: Shopify.shop,
                                    widgetId: widgetParams.id,
                                    userAddress: params.address,
                                }),
                            }
                        );
                        const res = await rawResponse.json();
                        await fetch(
                            "https://" + window.location.host + "/discount/" + res.discountCode
                        );
                        window.location.href = "/checkout";
                    },

                    onErrorCallback: () => {
                        console.log("error");
                    },
                    onUnconfirmCallback: () => {
                        console.log("not confirmed");
                    },
                };

                discountWidget = new EmbeddableWidget(discountWidgetParams);


                function unmountWidgetDiscount() {
                    try{discountWidget.unmount()} catch(e) {}
                }

                function mountWidgetDiscount() {
                    try{discountWidget.mount();} catch(e) {console.log(e)}
                }

                try{
                    try{unmountWidgetDiscount()}catch(e){}
                    const cartActions = document.querySelector('.cart-actions')
                    const discountWidgetWrapper = document.querySelector('#nftDiscountWidget')
                    if(cartActions) {
                        if(!discountWidgetWrapper) {
                            cartActions.insertAdjacentHTML('beforeend', '<div id="nftDiscountWidget"></div>');
                        }
                        mountWidgetDiscount()
                    }
                }catch(e){console.log(e)}

            }


//         function unmountWidgetDiscount() {EmbeddableWidgetDiscount.unmount()}

//         function mountWidgetDiscount() {EmbeddableWidgetDiscount.mount(gateWidgetParams)}

            async function checkCart() {
                setTimeout( async() => {
                    let isWidget = false

                    const res = await fetch(window.Shopify.routes.root + "cart.js" + "?nftScipDetection");
                    const cart = JSON.parse(await res.text())

                    for(let i = 0; i < cart.items.length; i++) {
                        const productRes = await fetch(window.Shopify.routes.root + 'products/' + cart.items[i].handle + ".js")
                        const product = JSON.parse(await productRes.text())

                        widgetSettings.forEach(item => {
                            if(product.tags.map(item => item.toLowerCase()).includes(item.productTag.toLowerCase()) && item.widgetType === 'Discount') {
                                isWidget = true
                                addDiscountWidget(isWidget, item)
                                return;
                            }
                        })

                    }

                    if(!isWidget) {
                        addDiscountWidget(isWidget)
                    }
                }, 1000)


            }

            if(window.location.href.includes('cart')) {
                checkCart()
            }

            const { fetch: originalFetch } = window;
            window.fetch = async (...args) => {
                let [resource, config ] = args;

                const response = await originalFetch(resource, config);

                if(
                    (
                        response.url.includes('cart/add') ||
                        response.url.includes('cart/clear') ||
                        response.url.includes('cart.js') ||
                        response.url.includes('cart/change')
                    ) &&
                    !response.url.includes('nftScipDetection')
                ) {
                    checkCart()
                }

                return response;
            };

            function addXMLRequestCallback(callback) {
                var oldSend, i;
                if (XMLHttpRequest.callbacks) {
                    XMLHttpRequest.callbacks.push(callback);
                } else {
                    XMLHttpRequest.callbacks = [callback];
                    oldSend = XMLHttpRequest.prototype.send;
                    XMLHttpRequest.prototype.send = function() {
                        for (i = 0; i < XMLHttpRequest.callbacks.length; i++) {
                            XMLHttpRequest.callbacks[i](this);
                        }
                        oldSend.apply(this, arguments);
                    }
                }
            }

            addXMLRequestCallback(async function(xhr) {

                if(
                    (
                        xhr._url.includes('cart/add') ||
                        xhr._url.includes('cart/clear') ||
                        xhr._url.includes('cart.js') ||
                        xhr._url.includes('cart/change')
                    ) &&
                    !xhr._url.includes('nftScipDetection')
                ) {
                    checkCart()
                }

            });
        }

    } catch(e) {
        console.log('nft discount widget error', e)
    }
})();